import { render, staticRenderFns } from "./CustomerAnalysis.vue?vue&type=template&id=b6b1f52e&scoped=true&lang=pug"
import script from "./CustomerAnalysis.vue?vue&type=script&lang=js"
export * from "./CustomerAnalysis.vue?vue&type=script&lang=js"
import style0 from "./CustomerAnalysis.vue?vue&type=style&index=0&id=b6b1f52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b1f52e",
  null
  
)

export default component.exports